const _excluded = ["rhf"],
  _excluded2 = ["rhf"],
  _excluded3 = ["rhf"],
  _excluded4 = ["rhf"],
  _excluded5 = ["rhf"],
  _excluded6 = ["rhf", "locale"],
  _excluded7 = ["rhf", "countryCode"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useController } from 'react-hook-form';
import { RhfFieldError, rhfMapper, useRhfTransformInterpolation } from "../../../rhf";
import { InputText } from "./input-text.component";
import { string } from "../../../validator/string";
import { bank } from "../../../validator/bank";
import { identity } from "../../../validator/identity";
import { InputTextOutlined } from "./input-text-outlined.component";
export const RhfInputText = props => {
  const {
    rhf,
    errorMessage,
    input,
    transform
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error,
      invalid,
      isTouched,
      isDirty
    },
    formState: {
      touchedFields,
      dirtyFields
    }
  } = useController(rhf);
  const interpolation = useRhfTransformInterpolation(value, transform);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputText, _extends({
    onChange: (c, e) => {
      const change = e ? interpolation(e) : c;
      onChange(change);
    },
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};
export const RhfInputTextOutlined = props => {
  const {
    rhf,
    errorMessage,
    input,
    transform
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error,
      invalid,
      isTouched,
      isDirty
    },
    formState: {
      touchedFields,
      dirtyFields
    }
  } = useController(rhf);
  const interpolation = useRhfTransformInterpolation(value, transform);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputTextOutlined, _extends({
    onChange: (c, e) => {
      const change = e ? interpolation(e) : c;
      onChange(change);
    },
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};
export const RhfInputToken = props => {
  const {
      rhf
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RhfInputText, _extends({
    rhf: rhfMapper(rhf, {
      valid: v => string.token(v)
    })
  }, rest)));
};
export const RhfInputUuid = props => {
  const {
      rhf
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RhfInputText, _extends({
    rhf: rhfMapper(rhf, {
      valid: v => string.validUuid(v)
    })
  }, rest)));
};
export const RhfInputIban = props => {
  const {
      rhf
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RhfInputText, _extends({
    rhf: rhfMapper(rhf, {
      valid: v => bank.validIBAN(v)
    })
  }, rest)));
};
export const RhfInputBic = props => {
  const {
      rhf
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RhfInputText, _extends({
    rhf: rhfMapper(rhf, {
      valid: v => bank.validBIC(v)
    })
  }, rest)));
};
export const RhfInputCreditCard = props => {
  const {
      rhf
    } = props,
    rest = _objectWithoutProperties(props, _excluded5);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RhfInputText, _extends({
    rhf: rhfMapper(rhf, {
      valid: v => bank.validCreditCard(v)
    })
  }, rest)));
};
export const RhfInputIdentityCard = props => {
  const {
      rhf,
      locale
    } = props,
    rest = _objectWithoutProperties(props, _excluded6);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RhfInputText, _extends({
    rhf: rhfMapper(rhf, {
      valid: v => identity.validIdentityCard(v, locale)
    })
  }, rest)));
};
export const RhfInputPassport = props => {
  const {
      rhf,
      countryCode
    } = props,
    rest = _objectWithoutProperties(props, _excluded7);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RhfInputText, _extends({
    rhf: rhfMapper(rhf, {
      valid: v => identity.validPassport(v, countryCode)
    })
  }, rest)));
};